import {INav} from 'features/layout/redux/helpers/FoldersHelper';
import {ITransaction} from 'types/diplomat/transaction/Transaction';
import {Trans, useTranslation} from 'react-i18next';
import {Typography} from '@mui/material';
import Box from '@mui/material/Box';
import Panel from 'components/Panel';
import ReferenceItems from 'features/layout/CommonPage/panels/ReferencesPanel/ReferenceItems';
import React from 'react';
import {ISynchronization} from 'types/diplomat/transaction/Synchronization';
import {
   transRefLabel,
   syncRefLabel,
   PARTNER_REFERENCE_TITLE,
   NO_TRANS_REFS,
   NO_SYNC_REFS,
} from 'common/strings';

type ReferencesAlertProps = {
   data: INav;
   objectName: string;
   transactions?: ITransaction[];
   synchronizations?: ISynchronization[];
};

const TransactionReferencesAlert = ({
   data,
   objectName,
   transactions,
   synchronizations,
}: ReferencesAlertProps) => {
   const {t} = useTranslation();
   const {name} = data;

   const transReferenceLabel = transRefLabel(objectName);
   const syncReferenceLabel = syncRefLabel(objectName);

   return (
      <>
         <Typography variant={'body2'}>
            <Trans t={t}>
               {{objectName}} "{{name}}" is referenced by one or more transactions.
               <strong>
                  If this {{objectNameLowerCase: objectName.toLowerCase()}} is deleted all related
                  transactions displayed below will be deleted automatically
               </strong>
            </Trans>
         </Typography>
         <Box paddingTop={2}>
            <Panel name={PARTNER_REFERENCE_TITLE}>
               {transactions && (
                  <ReferenceItems
                     name={transReferenceLabel}
                     data={transactions}
                     noData={NO_TRANS_REFS}
                  />
               )}
               {synchronizations && (
                  <ReferenceItems
                     name={syncReferenceLabel}
                     data={synchronizations}
                     noData={NO_SYNC_REFS}
                  />
               )}
            </Panel>
         </Box>
         <Typography variant={'body2'}>
            <Trans t={t}>
               Press "Cancel" to manually remove references to "{{name}}" in related transactions
               and synchroizations before proceeding. (Recommended)
            </Trans>
         </Typography>
         <Typography variant={'body2'}>
            <Trans t={t}>
               Press "OK" to continue with deletion of "{{name}}" and all related transactions and
               synchroizations.
            </Trans>
         </Typography>
      </>
   );
};

export default TransactionReferencesAlert;
